import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function OpticIcon(props) {
  return(
      <img src="/Icons/optic.svg" alt="optic" {...props}/>
  )
}